















import { defineComponent, reactive, ref } from '@vue/composition-api';

import useDownloadReport from '@/useDownloadReport';

import CommonYearStartOfYearSelector from '@/components/CommonYearStartOfYearSelect.vue';

const NOW_YEAR = new Date().getFullYear();
const DeliveryDuration = defineComponent({
  components: {
    CommonYearStartOfYearSelector,
  },
  setup() {
    const { getCSVReport } = useDownloadReport();
    const filter = reactive({
      range: {
        from: `${NOW_YEAR}-01-01`,
        to: `${NOW_YEAR}-12-31`,
      },
    });

    return {
      filter,
      getCSVReport,
    };
  },
});

export default DeliveryDuration;
